import { FC, PropsWithChildren } from 'react'

const FormSection: FC<PropsWithChildren> = ({ children }) => {
  return <div className='container border mb-2 p-2 mx-1'>{children}</div>
}

export default FormSection
